import { useParams } from 'react-router-dom';

import { DashboardsPage } from '../dashboards/DashboardsPage';

import PrivateEventDetailHeader from './PrivateEventDetailHeader';
import PrivateEventLoadState from './PrivateEventLoadState';
import TeacherPrivateEventBody from './TeacherPrivateEventBody';
import { usePrivateEventCrewView } from './usePrivateEvent';

/** TeacherPrivateEventPage — mounted at `/me/private-events/:id`. The admin
 *  detail page, read-only, for a teacher crewed on the event. */
export default function TeacherPrivateEventPage() {
  const { id = '' } = useParams<{ id: string }>();
  const { data: event, isLoading, error } = usePrivateEventCrewView(id);

  if (isLoading || error || !event) {
    return <PrivateEventLoadState loading={isLoading} error={error} />;
  }

  return (
    <DashboardsPage
      header={
        <PrivateEventDetailHeader clientName={event.clientName} lifecycle={event.lifecycle} />
      }
      stack={false}
    >
      <TeacherPrivateEventBody event={event} />
    </DashboardsPage>
  );
}
